{
  "ingredientUnit": {
    "bag": {
      "empty": "vreće",
      "plural": "vreće",
      "singular": "vreća"
    },
    "branch": {
      "empty": "grančice",
      "plural": "grančice",
      "singular": "grančica"
    },
    "bunch": {
      "empty": "vezice",
      "plural": "vezice",
      "singular": "vezica"
    },
    "can": {
      "empty": "konzerve",
      "plural": "konzerve",
      "singular": "konzerva"
    },
    "centiliter": {
      "empty": "cl",
      "plural": "cl",
      "singular": "cl"
    },
    "clove": {
      "empty": "češnja",
      "plural": "češnja",
      "singular": "češanj"
    },
    "cup": {
      "empty": "šalice",
      "plural": "šalice",
      "singular": "šalica"
    },
    "dash": {
      "empty": "mrvice",
      "plural": "mrvice",
      "singular": "mrvica"
    },
    "decigram": {
      "empty": "dg",
      "plural": "dg",
      "singular": "dg"
    },
    "deciliter": {
      "empty": "dl",
      "plural": "dl",
      "singular": "dl"
    },
    "drop": {
      "empty": "kapi",
      "plural": "kapi",
      "singular": "kap"
    },
    "fluidOunce": {
      "empty": "tekuće unce",
      "plural": "tekuće unce",
      "singular": "tekuća unca"
    },
    "gram": {
      "empty": "g",
      "plural": "g",
      "singular": "g"
    },
    "kilogram": {
      "empty": "kg",
      "plural": "kg",
      "singular": "kg"
    },
    "liter": {
      "empty": "l",
      "plural": "l",
      "singular": "l"
    },
    "microgram": {
      "empty": "mcg",
      "plural": "mcg",
      "singular": "mcg"
    },
    "milligram": {
      "empty": "mg",
      "plural": "mg",
      "singular": "mg"
    },
    "milliliter": {
      "empty": "ml",
      "plural": "ml",
      "singular": "ml"
    },
    "ounce": {
      "empty": "unce",
      "plural": "unce",
      "singular": "unca"
    },
    "package": {
      "plural": "paketa",
      "singular": "paket"
    },
    "piece": {
      "empty": "kom.",
      "plural": "kom.",
      "singular": "kom."
    },
    "pinch": {
      "empty": "prstohvata",
      "plural": "prstohvata",
      "singular": "prstohvat"
    },
    "pound": {
      "empty": "funte",
      "plural": "funte",
      "singular": "funta"
    },
    "sachet": {
      "empty": "vrećica",
      "plural": "vrećice",
      "singular": "vrećica"
    },
    "shot": {
      "empty": "čašice",
      "plural": "čašice",
      "singular": "čašica"
    },
    "slice": {
      "empty": "kriške",
      "plural": "kriške",
      "singular": "kriška"
    },
    "stick": {
      "empty": "štapića",
      "plural": "štapića",
      "singular": "štapić"
    },
    "tablespoon": {
      "empty": "jušne žlice",
      "plural": "jušne žlice",
      "singular": "jušna žlica"
    },
    "teaspoon": {
      "empty": "čajne žličice",
      "plural": "čajne žličice",
      "singular": "čajna žličica"
    }
  }
}